import { isClientSide } from './is-client-side'

const QUALIFICATION_KEY = 'nwwp_lead_magnet_qualified'
const INCOME_QUALIFICATION_KEY = 'nwwp_lead_magnet_income_qualified'

export const INVESTABLE_ASSETS_OPTIONS: { value: string; label: string }[] = [
  { value: 'UNDER_100K', label: 'Under $100,000' },
  { value: 'FROM_100_TO_250K', label: '$100,000 – $250,000' },
  { value: 'FROM_250_TO_500K', label: '$250,000 – $500,000' },
  { value: 'FROM_500K_TO_1M', label: '$500,000 – $1,000,000' },
  { value: 'OVER_1M', label: 'Over $1,000,000' },
]

function saveFlag(key: string, value: boolean): void {
  if (!isClientSide()) return
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value))
  } catch {
    // Storage can be blocked (private mode, quota, disabled) — not fatal.
  }
}

function loadFlag(key: string): boolean {
  if (!isClientSide()) return false
  try {
    return window.sessionStorage.getItem(key) === 'true'
  } catch {
    return false
  }
}

export function isLeadMagnetQualified(
  household_income: number | undefined,
  investable_assets_range: string | undefined
): boolean {
  return (
    (household_income ?? 0) >= 100_000 &&
    investable_assets_range !== undefined &&
    investable_assets_range !== 'UNDER_100K'
  )
}

export function saveLeadMagnetQualification(isQualified: boolean): void {
  saveFlag(QUALIFICATION_KEY, isQualified)
}

export function loadLeadMagnetQualification(): boolean {
  return loadFlag(QUALIFICATION_KEY)
}

/** Income-only check (household income ≥ $100K), independent of investable assets. */
export function isLeadMagnetIncomeQualified(household_income: number | undefined): boolean {
  return (household_income ?? 0) >= 100_000
}

export function saveLeadMagnetIncomeQualification(isQualified: boolean): void {
  saveFlag(INCOME_QUALIFICATION_KEY, isQualified)
}

export function loadLeadMagnetIncomeQualification(): boolean {
  return loadFlag(INCOME_QUALIFICATION_KEY)
}
